import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
		min: 'error.required',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
});

export const DepartmentSchema = yup.object().shape({
	name: yup.string().required(),

	departmentNumber: yup.string().required(),

	location: yup.string(),
});
